<template>
  <div class="pa-2 my-1">
    <div class="elevation-5" style="border-radius: 6px;"
         :class="[!compColor.isInDarkMode ? 'text--darken-1' : 'text--lighten-2']"
    :style="{'background': compColor.isInDarkMode ? '#00000033' : '#CFD8DC'}">

      <div class="flex blue-grey--text layout-row pa-2"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5  text--darken-1' : 'transparent  text--lighten-2']"
           style="border-radius: 6px 6px 0 0;">

        <div class="layout-column layout-align-center-center">
          <div class="pa-2" style="border-radius: 4px;" :class="compColor.prime">
            <v-icon size="30" color="white" v-if="source.gender === 'W'">mdi-gender-female</v-icon>
            <v-icon size="30" color="white" v-if="source.gender === 'M'">mdi-gender-male</v-icon>
            <v-icon size="30" color="white" v-if="source.gender === 'D'">mdi-gender-transgender</v-icon>
            <v-icon size="30" color="white" v-if="source.gender === 'U'">mdi-gender-male-female-variant</v-icon>
            <v-icon size="30" color="white" v-if="source.gender === 'X'">mdi-gender-non-binary</v-icon>
          </div>
        </div>

        <div class="layout-column px-3 py-0 layout-align-center-start">
          <div class="layout-row">
            <span class="font-weight-bold text-h6" style="line-height: 20px;">{{ source.lastname }}, {{ source.firstname }}</span>
          </div>

          <v-divider class="my-1" style="width: 100%;"></v-divider>

          <div class="body-2 layout-row">
            <v-icon size="13" :color="compColor.prime">mdi-cake-variant</v-icon>
            <span class="ml-2"
                  style="border-radius:3px;line-height:14px;display: inline-block;">{{ source.birthday | formatDate('DD.MM.YYYY') }}</span>
          </div>
        </div>

        <div class="ml-5 layout-column layout-align-center-start" v-if="allForms" style="font-size: 14px;">
          <v-checkbox :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      class="mt-0 py-0 mb-0"
                      height="40"
                      hide-details
                      @change="modifySelectedPatients(source.patientId, source.isSelected)"
                      :label="$t('COMPONENT_REPORT.PATIENT.LABEL_CHECKBOX_REPORT_PATIENT')"
                      v-model="source.isSelected">
          </v-checkbox>
        </div>

        <div class="flex"></div>

        <div class="layout-column px-3 py-0 layout-align-center-start">
          <div class="body-2 layout-row" @click="copyAisIdToClipboard(source.aisId, $event)" style="cursor: pointer;">
            <v-icon size="13" :color="compColor.prime">mdi-id-card</v-icon>
            <span class="ml-2 mr-1"
                  style="min-width:45px;line-height:23px;display: inline-block;">{{ source.aisId }}</span>
            <small style="opacity:0.5;line-height:23px;min-width: 40px;display: inline-block;">({{ $t('COMPONENT_REPORT.PATIENT.LABEL_AIS_ID') }})</small>
          </div>
        </div>
      </div>

      <v-divider :class="compColor.primeClass"></v-divider>

      <div v-for="(diagnosis, diagnosisIndex) in source.diagnoses" :key="diagnosisIndex">
        <div class="layout-row">

          <!-- Grunddaten Diagnose -->

          <div class="blue-grey--text layout-column px-4 py-2"
               style="border-radius: 3px;width:210px;">
            <div class="mb-1">
              <span class="caption">{{ $t('COMPONENT_REPORT.PATIENT.ICD_10_CODE') }}:</span><br>
              <span class="body-1 font-weight-bold">{{ diagnosis.primaerTumor.primaertumorIcdCode }}</span>
            </div>
            <div class="mb-1">
              <span class="caption">{{ $t('COMPONENT_REPORT.PATIENT.DIAGNOSIS_DATE') }}:</span><br>
              <span class="body-1 font-weight-bold">{{ diagnosis.primaerTumor.diagnosedatum | formatDate('DD.MM.YYYY') }}</span>
            </div>
            <div v-if="diagnosis.primaerTumor.seitenlokalisation">
              <span class="caption">{{ $t('COMPONENT_REPORT.PATIENT.DIAGNOSIS_SIDE_LOCALIZATION') }}:</span><br>
              <span class="body-1 font-weight-bold">{{ getFieldValue(diagnosis.primaerTumor.seitenlokalisation, 'SeitenlokalisationTypes') }}</span>
            </div>
          </div>

          <v-divider vertical></v-divider>

          <!-- Meldeformulare zur Diagnose -->

          <div class="flex px-2 py-0">

            <!-- Header des Formulares -->

            <div class="layout-column elevation-3 my-2"
                 style="border-radius: 5px;"
                 :class="{'mb-2': formIndex=== diagnosis.forms.length -1}"
                 :style="{ background: '#eee' }"
                 v-for="(form, formIndex) in diagnosis.forms" :key="formIndex">
              <div class="flex ml-2 layout-row">
                <div class="flex layout-row layout-align-start-center" style="height: 60px;">
                  <span class="blue-grey--text" style="width: 200px;font-weight: bold;">{{ $t('forms.' + form.key) }}</span>

                  <div class="pr-2" v-if="form.key !== 'register'">
                    <v-text-field
                      :value="form.date | formatDate('DD.MM.YYYY')"
                      dense
                      outlined
                      :label="$t('COMPONENT_IMPORT.DATE')"
                      :dark="isDarkMode"
                      disabled
                      class="has-colored-background mb-0 pt-5"
                    />
                  </div>

                  <!-- ------------------------ -->
                  <!--      Sonderfelder        -->
                  <!-- ------------------------ -->

                  <!-- Verlauf  Gesamtbeurteilung-->

                  <div class="px-2 mb-2 flex" v-if="form.key === 'progress'">
                    <fake-input-frame :label="$t('COMPONENT_REPORT.PATIENT.PROGRESS.OVERALL_ASSESSMENT_TUMOR')"
                                      disabled
                                      class="has-colored-background"
                                      height="50px">
                          <div class="pl-4 mb-2" style="font-size: 0.9em;color: rgba(0, 0, 0, 0.38);">
                            {{ getEvaluationForProgress(form) }}
                          </div>
                    </fake-input-frame>
                  </div>


                  <!-- syst. Therapie -->

                  <div class="px-2 layout-row flex" v-if="form.key === 'systemicTherapy'">

                    <!-- Wirkstoffe, keine vorhanden (fallback) -->

                    <fake-input-frame :label="$t('COMPONENT_REPORT.PATIENT.SYST_THERAPY.AGENTS')"
                                      v-if="(!form.agents || form.agents.length === 0) && !form.additionalFields.systemicTherapy.syst_no_agent"
                                      disabled
                                      height="50px"
                                      class="flex-gt-sm-35 has-colored-background">
                          <div class="pl-4 mb-2" style="font-size: 0.9em;color: rgba(0, 0, 0, 0.38);">{{ $t('COMPONENT_REPORT.PATIENT.SYST_THERAPY.NO_AGENTS') }}</div>
                    </fake-input-frame>

                    <!-- Wirkstoffe -->

                    <v-select
                      v-if="form.agents && form.agents.length > 0 && !form.additionalFields.systemicTherapy.syst_no_agent"
                      :color="compColor.primeColor"
                      :label="$t('COMPONENT_IMPORT.AGENTS')"
                      v-model="form.agents"
                      :items="getAgentList(form.agents)"
                      hide-details
                      disabled
                      outlined
                      class="mb-0 flex-gt-sm-35"
                      :dark="compColor.isInDarkMode"
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense>
                    </v-select>

                    <!-- Therapieart, wenn Checkbox "keine Wirkstoffe" ausgewählt -->

                    <fake-input-frame v-if="form.additionalFields.systemicTherapy.syst_no_agent"
                                      :label="$t('COMPONENT_REPORT.PATIENT.SYST_THERAPY.KIND_OF_THERAPY')"
                                      disabled
                                      height="50px"
                                      class="flex-gt-sm-50 mb-2 has-colored-background">
                          <div class="pl-4 mb-2" style="font-size: 0.9em;color: rgba(0, 0, 0, 0.38);">{{ getKindOfSystTherapyAsString(form) }}</div>
                    </fake-input-frame>

                    <!-- Therapieprotokoll, wenn Wirkstoffe -->

                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      v-if="!form.additionalFields.systemicTherapy.syst_no_agent && form.additionalFields.systemicTherapy.syst_protokoll"
                      :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                      :label="$t('COMPONENT_REPORT.PATIENT.SYST_THERAPY.PROTOCOL')"
                      hide-details
                      disabled
                      outlined
                      class="ml-2 mb-0 flex-gt-sm-15"
                      v-model="form.additionalFields.systemicTherapy.syst_protokoll"
                      dense
                    ></v-text-field>

                    <!-- Therapiebeginn, wenn Behandlungsende -->

                    <lx-datepicker
                      v-if="form.Meldeanlass === 'behandlungsende'"
                      :color="compColor.textInput"
                      :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE')"
                      hide-details
                      disabled
                      outlined
                      dense
                      class="ml-2 mb-0 flex-gt-sm-15"
                      v-model="form.additionalFields.systemicTherapy.syst_beginn_datum"
                    ></lx-datepicker>

                    <!-- Grund Ende, wenn Behandlungsende -->

                    <v-select
                      v-if="form.Meldeanlass === 'behandlungsende'"
                      :color="compColor.primeColor"
                      :label="$t('FORMS_DIVERSE.MODULE_SYST_REASON_FOR_END')"
                      v-model="form.additionalFields.systemicTherapy.syst_ende_grund"
                      :items="SYST_Ende_GrundTypes"
                      hide-details
                      disabled
                      outlined
                      dense
                      class="ml-2 mb-0 flex"
                      :menu-props="{ bottom: true, offsetY: true }"
                      :dark="compColor.isInDarkMode">
                    </v-select>
                  </div>

                  <!-- Strahlentherapie Applikationsart -->

                  <div class="px-2 mb-2 flex" v-if="form.key === 'radiationTherapy'">
                    <fake-input-frame :label="$t('COMPONENT_REPORT.PATIENT.RADIATION_THERAPY.KIND_OF_APPLICATION')"
                                      disabled
                                      class="has-colored-background"
                                      height="50px">
                          <div class="pl-4 mb-2" style="font-size: 0.9em;color: rgba(0, 0, 0, 0.38);">
                            {{ getDestinationOfRadiation(form) }}
                          </div>
                    </fake-input-frame>
                  </div>

                  <!-- Operationen  OPS-->

                  <div class="px-2 mb-2 flex" v-if="form.key === 'operation'" style="max-height: 50px;">
                    <fake-input-frame :label="$t('COMPONENT_REPORT.PATIENT.OPERATIONS')"
                                      disabled
                                      class="has-colored-background"
                                      height="50px">
                          <div class="pl-4 mb-2" style="font-size: 0.9em;color: rgba(0, 0, 0, 0.38);">
                            {{ getShortTextOfOperation(form) }}
                          </div>
                    </fake-input-frame>
                  </div>

                  <!-- Tumorkonferenz Typ -->

                  <div class="px-2 flex" v-if="form.key === 'tumorConference'">
                    <v-select
                      :color="compColor.primeColor"
                      :label="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_TYPE')"
                      v-model="form.additionalFields.tumorConference.typ"
                      :items="Tumorkonferenz_TypTypes"
                      hide-details
                      disabled
                      outlined
                      class="mb-0 has-colored-background"
                      :dark="isDarkMode"
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense>
                    </v-select>
                  </div>
                </div>

                <!-- Bearbeiten-Element, um ein Formular editierbar zu machen -->

                <div class="layout-row layout-align-center-center pr-3" v-show="!form.isEditable">
                  <v-icon size="14" :color="compColor.prime" class="mr-1" >edit</v-icon><span @click="form.isEditable = true" class="caption" style="cursor: pointer; font-weight: bold;" :class="compColor.primeClass">{{ $t('buttons.edit.value') }}</span>
                </div>
              </div>

              <v-divider style="border-color:rgba(0,0,0,0.1);"></v-divider>

              <!-- Inhalt des Formulares -->

              <div class="layout-row layout-wrap pt-4">

                <!-- Meldedatum -->

                <div class="flex-gt-sm-33 flex-100 px-2 mb-1">
                  <validation-provider tag="div"
                                       v-if="!form.isEditable"
                                       :name="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.Meldedatum'"
                                       :ref="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.Meldedatum'"
                                       rules="required"
                                       v-slot="{ errors }">
                    <v-text-field
                      :value="form.Meldedatum | formatDate('DD.MM.YYYY')"
                      dense
                      outlined
                      :label="$t('COMPONENT_REPORT.REPORT_DATE') + ' *'"
                      :dark="isDarkMode"
                      :hide-details="!errors || errors.length <= 0"
                      disabled
                      class="has-colored-background"
                    />
                  </validation-provider>

                  <validation-provider tag="div"
                                       v-if="form.isEditable"
                                       :name="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.Meldedatum'"
                                       :ref="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.Meldedatum'"
                                       rules="required|german_date|date_not_in_future"
                                       v-slot="{ errors }">
                    <lx-datepicker
                      v-if="form.isEditable"
                      :color="compColor.textInput"
                      :label="$t('COMPONENT_REPORT.REPORT_DATE') + ' *'"
                      class="mr-1 has-colored-background"
                      dense
                      :dark="isDarkMode"
                      :error="errors[0]"
                      :hideDetails="!errors || errors.length <= 0"
                      v-model="form.Meldedatum"
                    ></lx-datepicker>
                  </validation-provider>
                </div>

                <!-- Meldeanlass -->

                <div class="flex-gt-sm-33 flex-100 px-2 mb-1">
                  <validation-provider tag="div"
                                       :name="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.Meldeanlass'"
                                       :ref="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.Meldeanlass'"
                                       rules="required"
                                       v-slot="{ errors }">
                    <v-text-field
                      v-if="!form.isEditable"
                      class="ma-0 pa-0 has-colored-background"
                      dense
                      outlined
                      :label="$t('COMPONENT_REPORT.REPORT_CAUSE') + ' *'"
                      :color="compColor.primeColor"
                      :dark="compColor.isInDarkMode"
                      :hide-details="!errors || errors.length <= 0"
                      :name="'patientData' + index + 'diagnoses.' + diagnosisIndex + '.forms.' + formIndex + '.Meldeanlass'"
                      :value="getValueForKey(MeldeanlassTypes[form.key], form.Meldeanlass)"
                      disabled
                    />

                    <v-select
                      v-if="form.isEditable"
                      class="ma-0 pa-0 has-colored-background"
                      :label="$t('COMPONENT_REPORT.REPORT_CAUSE') + ' *'"
                      :items="MeldeanlassTypes[form.key]"
                      :name="'data.patients' + index + 'diagnoses.' + diagnosisIndex + '.forms.' + formIndex + '.Meldeanlass'"
                      @change="resetAdditionalElements(form)"
                      dense
                      outlined
                      :hide-details="!errors || errors.length <= 0"
                      :color="compColor.textInput"
                      :error="errors[0]"
                      :menu-props="{ bottom: true, offsetY: true }"
                      v-model="form.Meldeanlass"
                    />
                  </validation-provider>
                </div>

                <!-- Leistungserbringer -->

                <div class="flex-gt-sm-33 flex-100 px-2 mb-1">
                  <validation-provider tag="div"
                                       :name="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.reportHeader.reporter'"
                                       :ref="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.reportHeader.reporter'"
                                       rules=""
                                       class="layout-row flex"
                                       v-slot="{ errors }">

                    <!-- tooltip if reporter ist not in list and BAG is deactivated -->

                    <v-tooltip style="cursor: pointer;" top v-if="!isReporterInList(form.reportHeader) && !isMedicalCommunity">
                      <template v-slot:activator="{ on }" class="pr-3">
                        <v-icon v-on="on" :color="compColor.textInput" medium class="pb-4 pr-1">info</v-icon>
                      </template>
                      <span style="font-size: 14px;">{{
                          $t('COMPONENT_REPORT.MESSAGE_CARE_PROVIDER_NOT_IN_LIST', {
                            melderId: form.reportHeader.reporter.melderId,
                            name: form.reportHeader.reporter.name,
                            labelIdentNr: form.reportHeader.reporter && form.reportHeader.reporter.lanr ? 'LANR' : 'IKNR',
                            identNr: (form.reportHeader.reporter || {}).lanr || (form.reportHeader.reporter || {}).iknr
                          })
                        }}</span>
                    </v-tooltip>

                    <v-text-field
                      :name="'patientData' + index + 'diagnoses.' + diagnosisIndex + '.forms.' + formIndex + '.melderId'"
                      :value="form.reportHeader.reporter.name"
                      disabled
                      dense
                      class="has-colored-background"
                      outlined
                      :label="!isMedicalCommunity ? $t('COMPONENT_REPORT.CARE_PROVIDER') : $t('COMPONENT_CANCER_MESSAGE_DETAILS.CARE_PROVIDER') + ' *'"
                      :hide-details="!errors || errors.length <= 0"
                      :color="compColor.primeColor"
                      :dark="compColor.isInDarkMode"
                      v-if="!form.isEditable"
                    />

                    <v-select
                      v-if="form.isEditable"
                      :color="compColor.textInput"
                      :items="cancerFormDetails"
                      :error="errors[0]"
                      :label="!isMedicalCommunity ? $t('COMPONENT_REPORT.CARE_PROVIDER') : $t('COMPONENT_CANCER_MESSAGE_DETAILS.CARE_PROVIDER') + ' *'"
                      outlined
                      dense
                      class="has-colored-background"
                      :hide-details="!errors || errors.length <= 0"
                      :name="'data.patients.' + index + '.diagnoses.' + diagnosisIndex + '.forms.' + formIndex  + '.reportHeader.reporter'"
                      v-model="form.reportHeader.reporter"
                      :menu-props="{ bottom: true, offsetY: true }"
                    >
                      <template v-slot:selection='{ item }'>
                        {{ item.name }}
                      </template>

                      <template v-slot:item='{ item }'>
                        <div class="layout-row flex pt-1 pb-1 pl-3 pr-3"
                             style="border-bottom: 1px solid;"
                             :style="{'border-color': compColor.isInDarkMode ? '#546E7A' : '#eee'}">
                          <div class="flex layout-row mr-3" style="cursor: pointer;">
                            <lx-text-highlight :text="item.name" :search-string="item.name"
                                               :color="compColor.prime"></lx-text-highlight>
                            <span v-if="item.lanr" class="ml-2" :style="{ color: compColor.isInDarkMode ? '#546E7A' : 'rgba(0, 0, 0, 0.7)'}">(LANR: {{ item.lanr }} | Melder-ID: {{ item.melderId }})</span>
                            <span v-if="item.iknr" class="ml-2" :style="{ color: compColor.isInDarkMode ? '#546E7A' : 'rgba(0, 0, 0, 0.7)'}">(IKNR: {{ item.iknr }} | Melder-ID: {{ item.melderId }})</span>
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </validation-provider>
                </div>

                <!-- Alerts Leistungserbringer und Meldeanlass-->

                <div class="flex-gt-sm-100 flex-100 px-2 mb-2">
                  <!-- Alert if report header is incomplete (allForms is false)-->
                  <lx-alert-box color="red" v-if="(!form.Meldeanlass || !form.Meldedatum) && !allForms">
                    {{ $t('COMPONENT_REPORT.MESSAGE_INCOMPLETE_REPORT') }}
                  </lx-alert-box>

                  <!-- Alert if report header is incomplete and patient is selected (allForms is true)-->
                  <lx-alert-box color="red" v-if="(!form.Meldeanlass || !form.Meldedatum) && allForms && source.isSelected">
                    {{ $t('COMPONENT_REPORT.MESSAGE_INCOMPLETE_REPORT_ALL_FORMS') }}
                  </lx-alert-box>

                  <!-- Alert if no medical community and reporter is not logged in physician -->
                  <lx-alert-box color="orange" v-if="!isMedicalCommunity && form.reportHeader && form.reportHeader.reporter && form.reportHeader.reporter.melderId && form.reportHeader.reporter.melderId !== user.cancer_form_details.melder_id">
                    {{
                      $t('COMPONENT_REPORT.MESSAGE_DIFFERENT_REPORTER', {
                        name: form.reportHeader.reporter.name,
                        id: form.reportHeader.reporter.melderId,
                        labelIdentNr: form.reportHeader.reporter && form.reportHeader.reporter.lanr ? 'LANR' : 'IKNR',
                        identNr: (form.reportHeader.reporter || {}).lanr || (form.reportHeader.reporter || {}).iknr
                      })
                    }}
                  </lx-alert-box>

                  <!-- Alert if medical community and reporter is deleted member -->
                  <lx-alert-box color="orange" v-if="!isReporterInList(form.reportHeader) && isMedicalCommunity">
                    {{
                      $t('COMPONENT_REPORT.MESSAGE_DELETED_REPORTER', {
                        name: form.reportHeader.reporter.name,
                        melderId: form.reportHeader.reporter.melderId,
                        labelIdentNr: form.reportHeader.reporter && form.reportHeader.reporter.lanr ? 'LANR' : 'IKNR',
                        identNr: (form.reportHeader.reporter || {}).lanr || (form.reportHeader.reporter || {}).iknr
                      })
                    }}
                  </lx-alert-box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../../../common/utils'

export default {
  name: 'patient-component',
  mixins: [utils],
  props: {
    index: { // index of current item
      type: Number
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    },
    registerModules: Object,
    user: Object,
    cancerFormDetails: Array,
    selectedPatients: Array,
    allForms: Boolean,
    setAllPatientsAreSelected: Function
  },
  data () {
    return {
      MeldebegruendungTypes: null,
      MeldeanlassTypes: null,
      SYST_Ende_GrundTypes: null,
      Tumorkonferenz_TypTypes: null
    }
  },
  created () {
    this.MeldebegruendungTypes = this.formsMetaData.MeldebegruendungTypesSelect
    this.MeldeanlassTypes = this.formsMetaData.MeldeanlassTypes
    this.SYST_Ende_GrundTypes = this.formsMetaData.SYST_Ende_GrundTypes
    this.Tumorkonferenz_TypTypes = this.formsMetaData.Tumorkonferenz_TypTypes
  },
  methods: {
    /**
     * Copy selected aisId to clipboard
     *
     * @param aisId The aisId, selected by click-event
     * @param event The event, is necessary to know position of mouse-click
     */
    copyAisIdToClipboard (aisId, event) {
      // create textarea with text content to copy to clipboard
      let textArea = document.createElement('textarea')
      textArea.addEventListener('focusin', e => e.stopPropagation()) // must set, because of v-dialog has focus
      textArea.value = aisId
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      textArea.remove()

      // show little tooltip to user, that ais-id is copied
      let copied = document.createElement('div')
      copied.setAttribute('class', 'copied_ais_id')
      copied.setAttribute('style', 'left: ' + (event.pageX + 10) + 'px; top: ' + (event.pageY + 20) + 'px; background: ' + this.compColor.primeColor)
      copied.appendChild(document.createTextNode('AIS - ID kopiert'))
      document.body.appendChild(copied)
      setTimeout(() => {
        document.body.removeChild(copied)
      }, 1000)
    },

    /**
     * Add or delete patient to/from array of selectedPatients in dependency to its own state
     *
     * @param patientId The ObjectId of patient
     * @param state The selection state of patient
     */
    modifySelectedPatients (patientId, state) {
      if (state && this.selectedPatients.indexOf(patientId) < 0) this.selectedPatients.push(patientId)

      if (!state && this.selectedPatients.indexOf(patientId) >= 0) {
        this.selectedPatients.splice(this.selectedPatients.indexOf(patientId), 1)
      }

      // call function in ReportDialog to actualize value of AllPatientsAreSelected
      this.setAllPatientsAreSelected()
    },

    /**
     * Set default values for Meldedatum and Meldebegruendung of form, if form is selected
     * Delete Meldedatum, Meldebegruendung and Meldeanlass, if form is deselected
     *
     * @param form The selected form
     * @param item The diagnosis of selected form
     * @param patient The patient of diagnosis
     */
    // setFormDefaultValuesForReport (form, item, patient) {
    //   if (form && form.isSelected) {
    //     form.Meldedatum = new Date()
    //     form.Meldebegruendung = patient && patient.patient_informed_consent ? 'I' : 'W'
    //
    //     if (form && form.reportHeader && form.reportHeader.meldeanlass) {
    //       form.Meldeanlass = form.reportHeader.meldeanlass
    //     }
    //
    //     if (form && form.reportHeader && form.reportHeader.meldung_id) {
    //       form.Meldung_ID = form.reportHeader.meldung_id
    //     }
    //
    //     // set zusatzitem only if cancer register ask for it
    //     if (this.registerModules.Zusatzitem && this.registerModules.Zusatzitem.Forschungsvorhaben) {
    //       // use $set to make property observable
    //       this.$set(form, 'ZusatzitemForschung', {Wert: 'NB', Art: 'Teilnahme_Forschungsvorhaben'})
    //     }
    //
    //     // set zusatzitem only if cancer register ask for it
    //     if (form.key === 'register' && this.registerModules.Zusatzitem && this.registerModules.Zusatzitem.Diagnoseanlass) {
    //       // use $set to make property observable
    //       this.$set(form, 'ZusatzitemDiagnoseanlass', {Wert: 'F', Art: 'Diagnoseanlass'})
    //     }
    //   } else {
    //     delete form.Meldedatum
    //     delete form.Meldebegruendung
    //     delete form.Meldeanlass
    //     delete form.isRecentReport
    //     delete form.ZusatzitemDiagnoseanlass
    //     delete form.ZusatzitemForschung
    //   }
    //
    //   // set bool of diagnoses-selection and patient-selection to identify patients, which have diagnoses to report
    //   item.isSelected = item && item.forms ? item.forms.some(a => a.isSelected) : false
    //   patient.isSelected = patient && patient.diagnoses ? patient.diagnoses.some(a => a.isSelected) : false
    // },

    /**
     * Set Zusatzitem Diagnoseanlass to empty object if Meldeanlass is not diagnose and form is register
     *
     * @param form The selected form
     */
    resetAdditionalElements (form) {
      if (form && form.Meldeanlass && form.key === 'register' && form.Meldeanlass === 'diagnose' && this.registerModules?.Zusatzitem?.Diagnoseanlass) {
        this.$set(form, 'Zusatzitem_Diagnoseanlass', {Wert: 'F', Art: 'Diagnoseanlass'})
      } else {
        this.$set(form, 'Zusatzitem_Diagnoseanlass', {})
      }
    },

    /**
     * Show or hide tooltip in dependency of reporter in list of members of deactivated BAG
     *
     * @param formHeader The reporter object of form
     */
    isReporterInList (formHeader) {
      if (formHeader && formHeader.reporter && formHeader.reporter.melderId) {
        return this.cancerFormDetails.some(physician => (formHeader.reporter.lanr && physician.lanr === formHeader.reporter.lanr) || (formHeader.reporter.iknr && physician.iknr === formHeader.reporter.iknr))
      }

      return true
    },

    /**
     * Get the value from types object to display
     *
     * @param types The selection list
     * @param key The key in selection list to get text value
     */
    getValueForKey (types, key) {
      if (Array.isArray(types) && key) {
        const res = types.filter((type) => {
          return type.value === key
        })
        return res.length > 0 ? res[0].text : ''
      }

      return ''
    }
  },
  computed: {
    isMedicalCommunity () {
      return this.user && this.user.cancer_form_details && this.user.cancer_form_details.isMedicalCommunity
    }
  }
}
</script>

<style>
.copied_ais_id {
  position: absolute;
  width: 120px;
  height: 30px;
  padding-top: 6px;
  text-align: center;
  color: white;
  opacity: 0.6;
  vertical-align: middle;
  border-radius: 5px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  z-index: 999;
}
</style>
